import {
  cmsApiOnDepartureChangeSelector,
  cmsApiOnArrivalChangeSelector,
  departureCitySelector,
  arrivalCitySelector,
} from 'app/store/selectors';
import { switchLocations as switchLocationsAction } from 'app/store/reducers/location';
import { ThunkType } from 'app/hooks/appHooks';

export const switchLocations = (): ThunkType<void> => (dispatch, getState) => {
  dispatch(switchLocationsAction());

  const state = getState();
  const onDepartureCityChanged: ReturnType<typeof cmsApiOnDepartureChangeSelector> =
    cmsApiOnDepartureChangeSelector(state);
  const onArrivalCityChanged: ReturnType<typeof cmsApiOnArrivalChangeSelector> =
    cmsApiOnArrivalChangeSelector(state);
  const departureLocation: ReturnType<typeof departureCitySelector> = departureCitySelector(state);
  const arrivalLocation: ReturnType<typeof arrivalCitySelector> = arrivalCitySelector(state);

  if (departureLocation.name && departureLocation.uuid && departureLocation.legacyId) {
    const departurePayload = {
      uuid: departureLocation.uuid,
      legacyId: departureLocation.legacyId,
      cityName: departureLocation.name,
    };
    onDepartureCityChanged(departurePayload);
  }

  if (arrivalLocation.name && arrivalLocation.uuid && arrivalLocation.legacyId) {
    const arrivalPayload = {
      uuid: arrivalLocation.uuid,
      legacyId: arrivalLocation.legacyId,
      cityName: arrivalLocation.name,
    };

    onArrivalCityChanged(arrivalPayload);
  }
};
